<template>
  <main>
    <div id="changeTime" class="modal">
      <div class="modal-content" v-if="dateTime">
        <h4 style="text-align: center; margin-bottom: 3rem">
          Selecciona un rango para distribuir tus recargas:
        </h4>
        <div
          class="row justify-content-center my-4"
          style="color: white; margin-top: 1rem"
        >
          <div class=" subtitle col s4 offset-s1" style="cursor: pointer;">
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
            />
            <div class="center-align">
              <span
                class="material-symbols-outlined btn-style color"
                style="position: relative; top: 4px;"
                >today</span
              >
              <span
                class="prefix"
                style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Fecha Inicial:</span
              >
            </div>
            <input
              id="fecha_inicial"
              type="text"
              class="datepicker center-align"
              style="cursor: pointer;"
            />
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
            />
            <div class="center-align">
              <span
                class="material-symbols-outlined btn-style color"
                style="position: relative; top: 4px;"
                >schedule</span
              >
              <span
                class="prefix"
                style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Hora Inicial:</span
              >
            </div>
            <input
              id="hora_inicial"
              type="text"
              class="timepicker center-align"
              style="cursor: pointer;"
            />
          </div>

          <div class=" subtitle col s4 offset-s1" style="cursor: pointer;">
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
            />
            <div class="center-align">
              <span
                class="material-symbols-outlined btn-style color"
                style="position: relative; top: 4px;"
                >today</span
              >
              <span
                class="prefix"
                style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Fecha Final:</span
              >
            </div>
            <input
              id="fecha_final"
              type="text"
              class="datepicker center-align"
              style="cursor: pointer;"
            />
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
            />
            <div class="center-align">
              <span
                class="material-symbols-outlined btn-style color"
                style="position: relative; top: 4px;"
                >schedule</span
              >
              <span
                class="prefix"
                style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Hora Final:</span
              >
            </div>
            <input
              id="hora_final"
              type="text"
              class="timepicker center-align"
              style="cursor: pointer;"
            />
          </div>
        </div>
        <div class="modal-footer">
          <div
            class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
            @click="changeTime()"
            :class="'btn btn-l ' + disableProgramar"
            data-position="top"
            data-tooltip="Guardar Programación"
          >
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
            />
            <span class="material-symbols-outlined btn-style">
              calendar_clock
            </span>
          </div>
        </div>
        <div
          class=" waves-effect waves-light tooltipped  "
          @click="cerrarModal"
          style="position: absolute; 
          right: -0.5%;
          top: -2.5%;
          z-index: 1022;
          padding: 7px !important;
          color: #9C2626; 
          border: 2px

         "
          data-position="bottom"
          data-tooltip="Cancelar"
        >
          <link
            rel="stylesheet"
            href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
          />
          <span class="material-symbols-outlined btn-style" style="font-size: 40px;">
            cancel
          </span>
        </div>
      </div>
    </div>
    <div class="main-container">
      <div class="row right-align main">
        <div class="col s12 l10 offset-l1 card-panel movimientos" style="border-radius: 20px;">
          <div
              v-show="!isBlock"
              class="btn-floating \ waves-effect waves-light blue-grey back-button"
              @click="volver()"
          >
            <i class="material-icons">arrow_back</i>
          </div>

          <span class="page-title center-align">{{ titulo }}</span>
          <table
              v-show="isBlock"
              class="striped"
              style="text-align-last: center;"
          >
            <thead>
            <tr>
              <th v-for="titulo in titulos">{{ titulo }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(bloque, index) in bloques">
              <td>{{ bloque.lineas }}</td>
              <td>{{ bloque.recargadas }}</td>
              <td>${{ bloque.monto }}</td>
              <td>{{ bloque.fecha }}</td>
              <td>
                <div
                    class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                    @click="
                    pedirRecargasMasivas(bloque.fechaNumerica, bloque.fecha)
                  "
                    data-position="right"
                    data-tooltip="Detalles"
                >
                  <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                  />
                  <span class="material-symbols-outlined btn-style">
                    <span class="material-symbols-outlined">
                      quick_reference
                    </span>
                  </span>
                </div>
              </td>
              <td>
                <div
                    class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                    v-if="bloque.lineas !== bloque.recargadas"
                    :class="
                    'btn waves-effect waves-light green darken-2 ' +
                      bloque.disable
                  "
                    @click="recargaBloque(bloque.fechaNumerica, index)"
                    data-position="right"
                    data-tooltip="Recargar"
                >
                  <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                  />
                  <span class="material-symbols-outlined btn-style">
                    add_to_home_screen
                  </span>
                </div>
              </td>
              <td>
                <div v-if="isVcell && bloque.lineas !== bloque.recargadas">
                  <button
                      v-if="
                      recargasProgramadas.find(
                        (k) => k.fecha === bloque.fechaNumerica
                      )
                    "
                      title="Doble click para agendar la recarga "
                      :class="'btn waves-effect  red accent-4'"
                      @click="cancelarProgramacion(bloque.fechaNumerica)"
                  >
                    {{
                      recargasProgramadas.find(
                          (k) => k.fecha === bloque.fechaNumerica
                      ).stringStartDate
                    }}<i class="material-icons right">close</i>
                  </button>

                  <div
                      class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                      v-else
                      :class="'btn waves-effect  waves-light'"
                      @click="showModal(bloque)"
                      data-position="right"
                      data-tooltip="Programar"
                  >
                    <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                    />
                    <span class="material-symbols-outlined btn-style">
                      more_time
                    </span>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <table
              v-show="!isBlock"
              class="striped"
              style="text-align-last:center;"
          >
            <thead>
            <tr>
              <th v-for="titulo in titulos2">{{ titulo }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(bloque, index) in bloques2">
              <td>{{ bloque.icc }}</td>
              <td>{{ bloque.dn }}</td>
              <td>${{ bloque.monto }}</td>
              <td>{{ bloque.compania }}</td>
              <td>{{ bloque.nombre }}</td>
              <td>{{ bloque.fecha }}</td>
              <td class="center-align">
                <i
                    class="fa"
                    :class="{
                    fuenteVerde: bloque.isRecargado,
                    'fa-check': bloque.isRecargado,
                    'fa-times': !bloque.isRecargado,
                    fuenteRojo: !bloque.isRecargado,
                  }"
                    aria-hidden="true"
                ></i>
              </td>
              <td>
                <div
                    class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                    v-show="!bloque.isRecargado"
                    @click="recargaIndividual(bloque.id, index)"
                    :class="
                    'btn waves-effect waves-light green darken-2 ' +
                      bloque.disable
                  "
                    data-position="top"
                    data-tooltip="Recargar"
                >
                  <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                  />
                  <span class="material-symbols-outlined btn-style">
                    add_to_home_screen
                  </span>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </main>
</template>

<script>
let timepicker;
import {
  getBloquesRecargasMasivas,
  getRecargasMasivas,
  apiRecargarBloque,
  apiRecargaIndividual,
  apiChangeTime,
  apiGetRecargasProgramadas,
  apiCancelarProgramacion,
} from "@/api/api";
import { i18n } from "../constantes";
import { mapState } from "vuex";

export default {
  name: "recargaa",
  data() {
    return {
      dateTime: null,
      fecha_inicial: null,
      fecha_final: null,
      hora_inicial: null,
      hora_final: null,
      hora: null,
      recargasProgramadas: [],
      titulos: [],
      bloques: [],
      titulos2: [],
      bloques2: [],
      isBlock: true,
      titulo: "Bloques de recargas",
      disableProgramar: "",
      isVcell: false,
      barraAux: false,
    };
  },
  created() {
    this.$store.commit("ponerBarra");

    getBloquesRecargasMasivas()
      .then((response) => {
        console.log(response.data.titulos, localStorage.empresa)
        this.$store.commit("quitarBarra");
        if (
          localStorage.empresa === "vcell" ||
          localStorage.empresa === "demo" ||
          localStorage.empresa === "hashtag" ||
            localStorage.empresa === "HASHTAG" ||
          localStorage.empresa === "reyva" ||
          localStorage.empresa === "simcroft"
        ) {
          this.isVcell = true;
        } else {
          response.data.titulos.pop();
        }
        this.titulos = response.data.titulos;
        this.bloques = response.data.bloques;
      })
      .catch((error) => {
        this.$store.commit("quitarBarra");
        console.log(error);
        M.toast({
          html: error.message + "",
          classes: "rounded",
          displayLength: 4000,
        });
      });
    this.getRecargasProgramadas();
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.init();
      M.AutoInit();
    });
  },
  methods: {
    cerrarModal(){

      setTimeout(() => $("#changeTime").modal("close"), 1);
    },
    getRecargasProgramadas() {
      apiGetRecargasProgramadas()
        .then((resp) => {
          console.log(resp, `this`);
          this.$store.commit("quitarBarra");
          this.recargasProgramadas = resp;
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log(error);
          M.toast({
            html: error.message + "",
            classes: "rounded",
            displayLength: 4000,
          });
        });
    },
    changeTime() {
      console.log("poniendo barra");
      this.$store.commit("ponerBarra");
      this.barraAux = true;
      let fecha_inicial = document.getElementById("fecha_inicial").value;
      let hora_inicial = document.getElementById("hora_inicial").value;
      let fecha_final = document.getElementById("fecha_final").value;
      let hora_final = document.getElementById("hora_final").value;

      if (
        fecha_final === "" ||
        fecha_inicial === "" ||
        hora_inicial === "" ||
        hora_final === ""
      ) {
        M.toast({ html: "Todos los campos deben ser llenados" });
        return false;
      }
      if (fecha_final < fecha_inicial) {
        M.toast({ html: "La fecha final debe se mayor que la inicial 1" });
      }
      if (fecha_inicial === fecha_final && hora_final <= hora_inicial) {
        M.toast({ html: "La fecha final debe se mayor que la inicial" });
        return false;
      }
      let diaIni,
        mesIni,
        anioIni,
        diaFin,
        mesFin,
        anioFin,
        horaIni,
        horaFin,
        minIni,
        minFin;

      if (fecha_inicial.length > 2) {
        const fechaSeparada = fecha_inicial.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fecha_final.length > 2) {
        const fechaSeparada = fecha_final.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }
      if (hora_inicial.length !== 0) {
        const horaSeparada = hora_inicial.split(":");
        horaIni = horaSeparada[0];
        minIni = horaSeparada[1];
      }
      if (hora_final.length !== 0) {
        const horaSeparada = hora_final.split(":");
        horaFin = horaSeparada[0];
        minFin = horaSeparada[1];
      }
      let data = {
        identificador: this.dateTime,
        diaIni: diaIni,
        mesIni: mesIni,
        anioIni: anioIni,
        diaFin: diaFin,
        mesFin: mesFin,
        anioFin: anioFin,
        horaIni: horaIni,
        minIni: minIni,
        horaFin: horaFin,
        minFin: minFin,
      };
      apiChangeTime(data)
        .then((resp) => {
          console.log("quitando barra por ok");
          console.log(resp);
          this.$store.commit("quitarBarra");
          document.getElementById("fecha_inicial").value = "";
          document.getElementById("hora_inicial").value = "";
          document.getElementById("fecha_final").value = "";
          document.getElementById("hora_final").value = "";
          M.toast({
            html: "Recargas programadas correctamente",
            classes: "rounded",
            displayLength: 4000,
          });
          this.getRecargasProgramadas();
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log("imprimiendo el error", error);
          M.toast({
            html: error.message + "",
            classes: "rounded",
            displayLength: 4000,
          });
        });
    },
    init() {
      this.$nextTick(() => {
        M.AutoInit();
        const initialTime = document.getElementById("hora_inicial");
        const finalTime = document.getElementById("hora_final");
        M.Timepicker.init(initialTime, {
          twelveHour: false,
          defaultTime: "20:20",
        });
        M.Timepicker.init(finalTime, {
          twelveHour: false,
          defaultTime: "20:20",
        });
        M.Datepicker.init(document.querySelectorAll(".datepicker"), {
          format: "yyyy/mm/dd",
          i18n: i18n,
        });
      });
    },
    showModal(row) {
      this.dateTime = row.fechaNumerica;
      setTimeout(() => $("#changeTime").modal("open"), 1);
    },
    cancelarProgramacion(id) {
      let data = { id };
      apiCancelarProgramacion(data)
        .then((r) => {
          this.getRecargasProgramadas();
        })
        .catch((error) => {
          console.log(error);
          M.toast({ html: "No se pudo cancelar." });
        });
    },
    pedirRecargasMasivas(fechaNumerica, fecha) {
      this.$store.commit("ponerBarra");
      getRecargasMasivas(fechaNumerica)
        .then((response) => {
          this.$store.commit("quitarBarra");
          this.isBlock = false;
          this.titulo = "Recargas del " + fecha;
          this.bloques2 = response.data.recargas;
          this.titulos2 = response.data.titulos;
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log(error);
          M.toast({
            html: error.message + "",
            classes: "rounded",
            displayLength: 4000,
          });
        });
    },
    volver() {
      this.isBlock = true;
      this.titulos2 = [];
      this.bloques2 = [];
      this.titulo = "Bloques de recargas";
    },
    recargaIndividual(id, index) {
      this.$store.commit("ponerBarra");
      const auxBloques = this.bloques2.slice();
      auxBloques[index].disable = "disabled";
      this.bloques2 = auxBloques;
      apiRecargaIndividual(id)
        .then((res) => {
          this.$store.commit("quitarBarra");
          let auxMessage = "Recarga exitosa";
          if (res.message) auxMessage = res.message;
          else if (res.mensaje) auxMessage = res.mensaje;
          document.getElementById("player").play();
          M.toast({
            html: `${auxMessage}`,
            classes: "rounded",
            displayLength: 150000,
          });
          auxBloques[index].isRecargado = true;
          auxBloques[index].disable = "";
          this.bloques2 = auxBloques;
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          let auxMessage = "Recarga fallida";
          if (error.message) auxMessage = error.message;
          else if (error.mensaje) auxMessage = error.mensaje;
          this.mensaje = auxMessage;
          document.getElementById("player").play();
          M.toast({
            html: `${auxMessage}`,
            classes: "rounded",
            displayLength: 150000,
          });
          auxBloques[index].isRecargado = false;
          auxBloques[index].disable = "";
          this.bloques2 = auxBloques;
        });
    },
    recargaBloque(fecha, index) {
      this.$store.commit("ponerBarra");
      const auxBloques = this.bloques.slice();
      auxBloques[index].disable = "disabled";
      this.bloques = auxBloques;
      apiRecargarBloque(fecha)
        .then((res) => {
          const auxBloques = this.bloques.slice();
          auxBloques[index].disable = "";
          this.bloques = auxBloques;
          this.$store.commit("quitarBarra");
          let auxMessage = "Recarga exitosa";
          if (res.data.message) auxMessage = res.data.message;
          else if (res.data.mensaje) auxMessage = res.data.mensaje;
          document.getElementById("player").play();
          M.toast({
            html: `${auxMessage}`,
            classes: "rounded",
            displayLength: 150000,
          });
          auxBloques[index].disable = "";
          this.bloques = auxBloques;
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          let auxMessage = "Recarga fallida";
          if (error.response) {
            let auxError = error.response.data;
            if (auxError.message) auxMessage = auxError.message;
            else if (auxError.mensaje) auxMessage = auxError.mensaje;
            this.mensaje = auxMessage;
            M.toast({
              html: `${auxMessage}`,
              classes: "rounded",
              displayLength: 150000,
            });
            auxBloques[index].disable = "";
            this.bloques = auxBloques;
            player.play();
          }
        });
    },
  },
  computed: {
    ...mapState(["barra"]),
  },
};
</script>

<style scoped>
.modal-content {
  max-width: 800px; /* Ajusta el valor según tus necesidades */
  width: 100%;
  margin: 0 auto; /* Centra el modal en la pantalla */
}
.page-title {
  display: block;
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
.btn {
  width: 70px;
  text-align-last: center;
}
.btn-style {
  margin-top: 5px;
}
.titulo {
  font-size: 2.2em;
  display: block;
  margin-top: 5px;
  font-family: "Roboto", serif;
  font-weight: lighter;
}

.prefix {
  font-size: 1.4em;
  margin-top: 10px;
}

.card-panel {
  padding-top: 15px;
  padding-bottom: 15px;
}

.movimientos {
  width: 80%;
  margin-left: 10%;
  overflow-y: auto;
  max-height: 85vh;
  position: relative;
}

.main {
  margin-top: 20px;
}

.fuenteVerde {
  color: #00b134;
}

.fuenteRojo {
  color: #d60100;
}

td,
th {
  padding: 10px 5px;
}

.barraMovimientos {
  max-width: 100%;
  position: relative;
}

.back-button {
  position: absolute;
  left: 15px;
  margin-top: 5px;
}

.modal {
  border-radius: 20px;
  width: auto !important;
  max-width: 50% !important;
  overflow-y: inherit !important;
}

.modal-footer {
  margin-top: 4rem;
}

.subtitle {
  color: black;
}

.progress {
  top: 0;
  left: 0;
}

span.hide-on-med-and-down {
  font-size: 0.9rem;
}


.main-container {
  width: 94%;
  margin: 0 auto;
}
</style>
